// @ts-nocheck
// Lokalny hook listy dokumentów – rozszerzony typ o ksef_qr1, ksef_qr2 (KSEF)

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse
} from 'api/types';

export interface IDocumentListItem {
  id: number;
  symbol: string;
  currency: string;
  payment_datetime: string;
  payment_datetime_formatted: string;
  create_datetime: string;
  create_datetime_formatted: string;
  value_gross: number;
  value_gross_formatted: string;
  has_document_files: boolean;
  ksef_qr1?: string | null;
  ksef_qr2?: string | null;
  ksef_symbol?: string | null;
  ksef_status?: string | null;
  status_payment_formatted: {
    id: number;
    name: string;
    icon: string;
    color: string;
    show_button_pay: boolean;
    button_type: string;
  };
}

export type IRequest = IPaginationRequest & {
  document_type: 'PROFORMA' | 'INVOICE' | 'CORRECTIVE_INVOICE';
};

type IResponse = IPaginationResponse<IDocumentListItem>;

const getDocuments = (params?: IRequest): Promise<IResponse> =>
  axios.get('/documents', { params });

export const useGetDocuments = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) => useQuery<IResponse, IError>(['documents', params], () => getDocuments(params), options);
